'use client';

import { useConnection } from '@splace/core';

/**
 * Tiny corner indicator: invisible while the socket is connected, a
 * pulsing dot + label appears at the bottom-left when the channel is
 * down or the browser is offline. Mono font, dim color, doesn't push
 * any layout — purely informational.
 */
export function ConnectionStatus() {
  const status = useConnection(s => s.status);
  if (status === 'online') return null;

  const label = status === 'offline' ? 'offline' : 'reconnecting…';

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 12,
        left: 12,
        zIndex: 200,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 'var(--r-pill)',
        background: 'rgba(0,0,0,.55)',
        backdropFilter: 'blur(8px)',
        border: '1px solid var(--line)',
        color: 'var(--text-muted)',
        fontFamily: 'var(--font-mono)',
        fontSize: 11,
        letterSpacing: '.04em',
        pointerEvents: 'none',
      }}
    >
      <span
        style={{
          width: 6, height: 6, borderRadius: '50%',
          background: status === 'offline' ? 'var(--accent)' : 'var(--text-dim)',
          animation: status === 'offline' ? 'none' : 'cs-pulse 1.4s ease-in-out infinite',
        }}
      />
      {label}
      <style>{`
        @keyframes cs-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .35; }
        }
      `}</style>
    </div>
  );
}
